module.exports = __webpack_public_path__ + "static/img/tool.0517196.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/tool.jpg
// module id = 5L8s
// module chunks = 10